import { NgModule } from '@angular/core';
import { HoldingsContainerComponent } from './holdings.container';

import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { CommonModule, DecimalPipe } from '@angular/common';
import { ChartsModule } from '../../shared/charts/charts.module';
import { EffectsModule } from '@ngrx/effects';
import { HoldingsEffects } from './holdings.effects';
import { SharedModule } from '../../shared/shared.module';
import { PipesModule } from '../../global/pipes/pipes.module';
import { LegacyModule } from 'atlas-legacy';
import { CdkModule } from 'atlas-cdk';
import { TableModule } from 'atlas-table';
import { IconModule } from 'atlas-icon';
import { TabsModule } from 'atlas-tabs';
import { TooltipModule } from 'atlas-tooltip';
import { FieldModule } from 'atlas-field';
import { MenuModule } from 'atlas-menu';
import { ListModule } from 'atlas-list';
import { LinkModule } from 'atlas-link';
export const COMPONENTS = [
  HoldingsContainerComponent
];

@NgModule({
  declarations: COMPONENTS,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    // MercerOSModule,
    ChartsModule,
    SharedModule,
    PipesModule,
    LegacyModule,
    CdkModule,
    IconModule,
    TableModule,
    TabsModule,
    TooltipModule,
    FieldModule,
    MenuModule,
    ListModule,
    LinkModule,
    EffectsModule.forFeature([HoldingsEffects])
  ],
  exports: COMPONENTS,
  providers: [DecimalPipe],
  bootstrap: [],
})
export class HoldingsModule {
}
